<div class="text-dark">
  <h5 mat-dialog-title class="mb-2 pb-0 px-3" data-test="callback-details-title">Callback Attempt Details</h5>
  <div class="dialog-content px-3 py-2" data-test="callback-details-content">
    <p class="text-dark" data-test="callback-id"><strong>Attempt ID:</strong> {{ data.id }}</p>
    <p class="text-dark" data-test="callback-msg-id"><strong>Message ID:</strong> {{ data.msgId }}</p>
    <p class="text-dark" data-test="callback-status"><strong>Status:</strong> {{ data.status }}</p>
    <p class="text-dark" data-test="callback-status-code"><strong>Status Code:</strong> {{ data.responseStatusCode }}
    </p>
    <p class="text-dark" data-test="callback-duration"><strong>Duration:</strong> {{ data.responseDurationMs }} ms</p>
    <p class="text-dark" data-test="callback-timestamp"><strong>Requested Date:
      :</strong> {{ data.timestamp | date: 'dd/MM/yy HH:mm:ss' }}</p>
    <p class="text-dark" data-test="callback-url">
      <strong>URL:</strong>&nbsp;<span data-test="callback-url-link">{{ data.url }}</span>
    </p>


    <div class="mt-2 border border-1 rounded-3 mb-3 w-100">
      <div class="d-flex align-items-center justify-content-between px-2 py-2 w-100">
        <p class="text-dark fw-bold my-0">Response:</p>

        <button mat-button (click)="copyCallbackResponse()" data-test="copy-response-button"
                class="bg-white-always mon-border-primary border mon-text-primary d-flex align-items-center justify-content-center gap-2">
          <mat-icon>content_copy</mat-icon>
          Copy Response
        </button>
      </div>
      <div class="rounded-3 bg-light p-2">
        <div style="max-height: 300px" class="overflow-auto">
        <pre class="text-dark" data-test="callback-response-preview">
          {{ data.response }}
        </pre>
        </div>
      </div>
    </div>

  </div>

  <mat-dialog-actions class="px-3" align="end">
    <button mat-button mat-dialog-close class="bg-white-always mon-border-warning border mon-text-warning"
            data-test="callback-close-button">Close
    </button>
  </mat-dialog-actions>
</div>
